import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, styled, Typography } from '@mui/material'
import { sanitize } from 'dompurify'
import type { FC } from 'react'

import { ICONS, unit } from '@hcr/pwa/components'

import { Drawer } from '../../../common'

interface DestinationDrawerProps {
  description: string
  isOpen: boolean
  onClose: () => void
  resortName: string
  title: string
}

export const DestinationDrawer: FC<DestinationDrawerProps> = ({ description, isOpen, onClose, resortName, title }) => {
  return (
    <Drawer open={isOpen} onClose={onClose} anchor='bottom'>
      <Container>
        <CloseIcon onClick={onClose}>
          <FontAwesomeIcon icon={ICONS.farXmark} />
        </CloseIcon>
        <TextContainer>
          <Typography variant='labelM'>{resortName}</Typography>
          <TypographyWithPadding variant='headlineS'>{title}</TypographyWithPadding>
          <Typography variant='bodyM' dangerouslySetInnerHTML={{ __html: sanitize(description) }} />
        </TextContainer>
      </Container>
    </Drawer>
  )
}

const Container = styled(Box)`
  max-height: 65vh;
`

const CloseIcon = styled(Box)`
  cursor: pointer;
  display: flex;
  justify-content: end;
  font-size: ${unit(6)};
`

const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`

const TypographyWithPadding = styled(Typography)`
  padding-bottom: ${unit(3)};
`
